var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('p',{staticClass:"\n    text-muted text-center"},[_c('i',{staticClass:"feather icon-search display-4 d-block m-3"}),_vm._v("\n       - Nessuna risorsa trovata -\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }